(() => {
  if (customElements.get('tp-back-in-stock')) return;

  class TPBackInStock extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.tp-back-in-stock__dialog');
      this.trigger = this.querySelector('.tp-back-in-stock__trigger');
      this.form = this.querySelector('.tp-back-in-stock__form');
      this.closeButton = this.querySelector('.tp-back-in-stock__close');
      this.selection = this.querySelector('[data-tp-bis-selection]');
      this.error = this.querySelector('[data-tp-bis-error]');
      this.success = this.querySelector('[data-tp-bis-success]');

      this.trigger?.addEventListener('click', () => this.open());
      this.closeButton?.addEventListener('click', () => this.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.form?.addEventListener('submit', (event) => this.submit(event));

      document.addEventListener('variant:update', (event) => this.handleVariantEvent(event));
      document.addEventListener('variant:selected', () => requestAnimationFrame(() => this.syncFromProductForm()));

      this.render();
    }

    handleVariantEvent(event) {
      const detail = event.detail || {};
      const variant = detail.variant || detail.resource || detail;
      const productId = String(detail.productId || variant?.product_id || '');

      if (productId && productId !== String(this.dataset.productId)) return;

      if (variant?.id) {
        this.dataset.variantId = variant.id;
        if (typeof variant.available === 'boolean') this.dataset.variantAvailable = String(variant.available);
        if (variant.title) this.dataset.variantTitle = variant.title;
        this.render();
        return;
      }

      requestAnimationFrame(() => this.syncFromProductForm());
    }

    syncFromProductForm() {
      const scope = this.closest('product-form-component') || this.closest('.buy-buttons-block')?.querySelector('product-form-component');
      const variantInput = scope?.querySelector('input[name="id"]');
      if (variantInput?.value) this.dataset.variantId = variantInput.value;

      const addButton = scope?.querySelector('button[type="submit"]');
      if (addButton) this.dataset.variantAvailable = String(!addButton.disabled);
      this.render();
    }

    render() {
      const available = this.dataset.variantAvailable === 'true';
      this.classList.toggle('hidden', available || !this.dataset.variantId);

      if (this.selection) {
        const variantTitle = this.dataset.variantTitle;
        const showVariant = variantTitle && variantTitle !== 'Default Title';
        this.selection.textContent = showVariant
          ? `${this.dataset.productTitle} – ${variantTitle}`
          : this.dataset.productTitle;
      }
    }

    open() {
      this.resetMessages();
      this.dialog?.showModal();
      requestAnimationFrame(() => this.querySelector('.tp-back-in-stock__email')?.focus());
    }

    close() {
      this.dialog?.close();
    }

    resetMessages() {
      if (this.error) {
        this.error.hidden = true;
        this.error.textContent = '';
      }
      if (this.success) this.success.hidden = true;
      if (this.form) this.form.hidden = false;
    }

    async submit(event) {
      event.preventDefault();
      const emailInput = this.querySelector('.tp-back-in-stock__email');
      const submitButton = this.querySelector('.tp-back-in-stock__submit');
      const email = emailInput?.value.trim();

      if (!emailInput?.checkValidity()) {
        emailInput?.reportValidity();
        return;
      }

      if (!email || !this.dataset.variantId) return;

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (this.error) this.error.hidden = true;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${this.dataset.variantId}`,
              },
            },
          },
        },
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.publicApiKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2025-07-15',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok && response.status !== 202) throw new Error(`Klaviyo BIS request failed: ${response.status}`);

        this.form.hidden = true;
        this.success.hidden = false;
        emailInput.value = '';
      } catch (error) {
        console.error(error);
        if (this.error) {
          this.error.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
          this.error.hidden = false;
        }
      } finally {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('tp-back-in-stock', TPBackInStock);
})();
